import React, { Component } from "react";
import { connect } from "react-redux";
import Paper from "@material-ui/core/Paper";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Collapse from "@material-ui/core/Collapse";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import DocumentType from "../DocumentType";
import ChipInput from "material-ui-chip-input";
import { DatePicker } from "@material-ui/pickers";
import CoreFilter from "../filter/CoreFilter";
import TaxonomySelector from "./../taxonomy/TaxonomySelector";
import Button from "@material-ui/core/Button";
import { withLastLocation } from "react-router-last-location";
import { Badge } from "@material-ui/core";
import Icon from "@mdi/react";
import { Chip } from "@material-ui/core";
import { mdiFilterVariantRemove, mdiFilterVariant } from "@mdi/js";
import ListItemText from "@material-ui/core/ListItemText";
import KpsListItem from "../../core-elements/KpsListItem";
import Grid from "@material-ui/core/Grid";
import DocumentCategories from "../document/DocumentCategories";
import SearchLanguages from "./SearchLanguages";

const styles = (theme) => ({
  popper: {
    zIndex: 1,
    minWidth: 500,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${
          theme.palette.common.white
        } transparent`,
      },
    },
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  formControl: {
    marginTop: 12,
    margin: 6,
    minWidth: 120,
  },
  taxonomyNodePicker: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  formControlChip: {
    margin: 4,
    minWidth: 120,
  },
  chipInput: {
    maxWidth: 150,
    marginTop: 0,
  },
  chipContainer: {
    marginTop: 10,
  },
  formWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  mainFilters: {
    marginBottom: theme.spacing(5),
  },
  filterLine: {
    // display: "flex",
    marginLeft: "auto",
    marginRight: "auto",
  },
  container: {},
  paperRoot: {
    display: "flex",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    flexDirection: "column",
    marginBottom: 5,
  },
  expandedContainer: {
    display: "flex",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    flexWrap: "wrap",
  },
});
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangle: {
    transform: "translate(-150%, 50%)",
  },
  badge: {
    // left: -8,
    // top: 13,
    // border: `2px solid ${theme.palette.background.paper}`,
    // padding: '0 4px',
  },
}))(Badge);

export class SearchFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: "10",
      liveDraft: "Live",
      anyWordExact: [],
      allWordExact: [],
      exactPhrase: [],
      noWordExact: [],
      createdDateRangeStart: null,
      createdDateRangeEnd: null,
      lastModifiedDateRangeStart: null,
      lastModifiedDateRangeEnd: null,
      documentTypes: [],
      expanded: false,
      defaultFilters: this.props.isMobile && this.props.isMobile === true ?
      ["taxonomy"]
      : 
      [
        "taxonomy",
        "categories",
        "liveDraft",
        "languages",
        "documentTypes",
        "anyWordExact",
      ],
    };
  }

  onCategoriesUpdate = (categories) => {
    let event = {};
    event.target = {};
    event.target.name = "categories";
    event.target.value = categories.map((c) => c.id);
    this.props.handleChange(event);
  };

  onLanguagesUpdate = (languages) => {
    let event = {};
    event.target = {};
    event.target.name = "languages";
    event.target.value = languages;
    this.props.handleChange(event);
  };

  handleArrowRef = (node) => {
    this.setState({
      arrowRef: node,
    });
  };
  activateSearch = () => {
    this.props.history.push(`/search/`);
  };

  render() {
    const { classes, t } = this.props;
    let filterObj = {};
    filterObj.anyWordExact = (
      <FormControl className={classes.formControlChip}>
        {this.props.filter.anyWordExact && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <ChipInput
          id="search-filter-any-words"
          classes={{ root: this.props.classes.chipInput }}
          fullWidthInput={false}
          value={
            this.props.filter.anyWordExact
              ? [...this.props.filter.anyWordExact]
              : []
          }
          onAdd={(chip) => this.props.addChip("anyWordExact", chip)}
          onDelete={(chip) => this.props.deleteChip("anyWordExact", chip)}
          newChipKeyCodes={[9, 13, 32]}
          margin="dense"
          chipRenderer={(
            { text, handleDelete, isDisabled, className },
            key
          ) => {
            return (
              <Chip
                label={text}
                onDelete={handleDelete}
                disabled={isDisabled}
                size="small"
                key={key}
                className={className}
              />
            );
          }}
          label={this.props.t("search_bar_any_words")}
        />
      </FormControl>
    );
    filterObj.allWordExact = (
      <FormControl className={classes.formControlChip}>
        {this.props.filter.allWordExact && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <ChipInput
          id="search-filter-all-words"
          className={classes.chipInput}
          fullWidthInput={false}
          value={
            this.props.filter.allWordExact
              ? [...this.props.filter.allWordExact]
              : []
          }
          onAdd={(chip) => this.props.addChip("allWordExact", chip)}
          onDelete={(chip) => this.props.deleteChip("allWordExact", chip)}
          newChipKeyCodes={[9, 13, 32]}
          label={t("search_bar_all_words")}
        />
      </FormControl>
    );
    filterObj.exactPhrase = (
      <FormControl className={classes.formControlChip}>
        {this.props.filter.exactPhrase && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <ChipInput
          id="search-filter-exact-phrase"
          className={classes.chipInput}
          fullWidthInput={false}
          value={
            this.props.filter.exactPhrase
              ? [...this.props.filter.exactPhrase]
              : []
          }
          onAdd={(chip) => this.props.addChip("exactPhrase", chip)}
          onDelete={(chip) => this.props.deleteChip("exactPhrase", chip)}
          newChipKeyCodes={[9, 13]}
          label={t("search_bar_exact_phrase")}
        />
      </FormControl>
    );
    filterObj.noWordExact = (
      <FormControl className={classes.formControlChip}>
        {this.props.filter.noWordExact && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <ChipInput
          id="search-filter-no-words"
          className={classes.chipInput}
          value={
            this.props.filter.noWordExact
              ? [...this.props.filter.noWordExact]
              : []
          }
          onAdd={(chip) => this.props.addChip("noWordExact", chip)}
          onDelete={(chip) => this.props.deleteChip("noWordExact", chip)}
          newChipKeyCodes={[9, 13, 32]}
          label={t("search_bar_no_words")}
        />
      </FormControl>
    );
    filterObj.createdDateRangeStart = (
      <FormControl className={classes.formControl}>
        {this.props.filter.createdDateRangeStart && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DatePicker
          id="search-filter-created-from"
          autoOk
          label={t("search_bar_created_from")}
          clearable
          disableFuture
          value={
            this.props.filter.createdDateRangeStart
              ? this.props.filter.createdDateRangeStart
              : this.state.createdDateRangeStart
          }
          onChange={this.props.handleDateChange("createdDateRangeStart")}
        />
      </FormControl>
    );
    filterObj.createdDateRangeEnd = (
      <FormControl className={classes.formControl}>
        {this.props.filter.createdDateRangeEnd && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DatePicker
          id="search-filter-created-to"
          autoOk
          label={t("search_bar_created_to")}
          clearable
          disableFuture
          value={
            this.props.filter.createdDateRangeEnd
              ? this.props.filter.createdDateRangeEnd
              : this.state.createdDateRangeEnd
          }
          onChange={this.props.handleDateChange("createdDateRangeEnd")}
        />
      </FormControl>
    );
    filterObj.lastModifiedDateRangeStart = (
      <FormControl className={classes.formControl}>
        {this.props.filter.lastModifiedDateRangeStart && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DatePicker
          id="search-filter-updated-from"
          autoOk
          label={t("search_bar_updated_from")}
          clearable
          disableFuture
          value={
            this.props.filter.lastModifiedDateRangeStart
              ? this.props.filter.lastModifiedDateRangeStart
              : this.state.lastModifiedDateRangeStart
          }
          onChange={this.props.handleDateChange("lastModifiedDateRangeStart")}
        />
      </FormControl>
    );
    filterObj.lastModifiedDateRangeEnd = (
      <FormControl className={classes.formControl}>
        {this.props.filter.lastModifiedDateRangeEnd && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DatePicker
          id="search-filter-updated-to"
          autoOk
          label={t("search_bar_updated_to")}
          clearable
          disableFuture
          value={
            this.props.filter.lastModifiedDateRangeEnd
              ? this.props.filter.lastModifiedDateRangeEnd
              : this.state.lastModifiedDateRangeEnd
          }
          onChange={this.props.handleDateChange("lastModifiedDateRangeEnd")}
        />
      </FormControl>
    );
    filterObj.taxonomy = (
      <FormControl className={classes.formControl}>
        {this.props.isFilterSet("taxonomy") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <TaxonomySelector
          limitWithTeam
          id="search-filters-taxonomy-selector"
          multiSelect={true}
          allowedSelections={["taxonomy", "topic"]}
          filter={
            this.props.filter.taxonomy
              ? this.props.filter.taxonomy
              : this.props.taxonomyNodeLookup
          }
          onNodeSelected={this.props.setTaxonomy}
        />
      </FormControl>
    );
    filterObj.categories = (
      <FormControl className={classes.formControl}>
        {this.props.isFilterSet("categories") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DocumentCategories onChange={this.onCategoriesUpdate} />
      </FormControl>
    );
    filterObj.liveDraft = (
      <>
        {(this.props.currentUser.userPermits.roles.beExpert ||
          this.props.currentUser.userPermits.roles.systemManager) && (
          <FormControl className={classes.formControl}>
            {this.props.isFilterSet("liveDraft") && (
              <StyledBadge
                color="secondary"
                variant="dot"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              />
            )}
            <InputLabel id="live-draft">
              <Trans i18nKey="search_bar_live_draft" />
            </InputLabel>
            <Select
              MenuProps={{
                style: { zIndex: 35001 },
              }}
              id="search-filters-live-draft"
              labelId="live-draft"
              value={
                this.props.filter.liveDraft
                  ? this.props.filter.liveDraft
                  : this.state.liveDraft
              }
              onChange={this.props.handleChange}
              inputProps={{
                name: "liveDraft",
              }}
            >
              <MenuItem value={"All"}>
                <Trans i18nKey="global_all" />
              </MenuItem>
              <MenuItem value={"Live"}>
                <Trans i18nKey="global_document_live" />
              </MenuItem>
              <MenuItem value={"Draft"}>
                <Trans i18nKey="global_document_draft" />
              </MenuItem>
            </Select>
          </FormControl>
        )}
      </>
    );
    filterObj.languages = (
      <FormControl className={classes.formControl}>
        {this.props.isFilterSet("languages") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <SearchLanguages
          value={this.props.filter.languages}
          onChange={this.onLanguagesUpdate}
        />
      </FormControl>
    );
    filterObj.documentTypes = (
      <FormControl className={classes.formControl}>
        {this.props.filter.documentTypes && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DocumentType
          id="search-filters-document-type"
          search
          multiSelect={true}
          doctypes={this.props.documentTypes}
          docTypeSelected={this.props.handleSelectChange}
          documentType={
            this.props.filter.documentTypes
              ? this.props.filter.documentTypes
              : this.state.documentTypes
          }
        />
      </FormControl>
    );
    const activeFilters = (
      <>
        {!this.state.expanded &&
          Object.keys(this.props.filter)
            .filter((filter) => this.props.isFilterSet(filter))
            .map((filter, idx) => (
              <Grid item>
                {filterObj.hasOwnProperty(filter) &&
                  this.state.defaultFilters.indexOf(filter) < 0 &&
                  filterObj[filter]}
              </Grid>
            ))}
      </>
    );
    const wordSummary = (
      <>
        {this.props.isFilterSet("anyWordExact") ||
        this.props.isFilterSet("allWordExact") ||
        this.props.isFilterSet("exactPhrase") ||
        this.props.isFilterSet("noWordExact") ? (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <Trans i18nKey="global_words" />
          </StyledBadge>
        ) : (
          <Trans i18nKey="global_words" />
        )}
      </>
    );
    let defaultFilters = (
      <>
        {this.state.defaultFilters.map((filter, idx) => (
          <Grid item>
            {filterObj.hasOwnProperty(filter) && filterObj[filter]}
          </Grid>
        ))}
      </>
    );
    const wordDetails = (
      <div className={classes.filterLine}>
        {(!this.props.isFilterSet("anyWordExact") || this.state.expanded) &&
          this.state.defaultFilters.indexOf("anyWordExact") < 0 && (
            <Grid item>{filterObj.anyWordExact}</Grid>
          )}
        {(!this.props.isFilterSet("allWordExact") || this.state.expanded) &&
          this.state.defaultFilters.indexOf("allWordExact") < 0 && (
            <Grid item>{filterObj.allWordExact}</Grid>
          )}
        {(!this.props.isFilterSet("exactPhrase") || this.state.expanded) &&
          this.state.defaultFilters.indexOf("exactPhrase") < 0 && (
            <Grid item>{filterObj.exactPhrase}</Grid>
          )}
        {(!this.props.isFilterSet("noWordExact") || this.state.expanded) &&
          this.state.defaultFilters.indexOf("noWordExact") < 0 && (
            <Grid item>{filterObj.noWordExact}</Grid>
          )}
      </div>
    );
    const dateDetails = (
      <>
        {(!this.props.isFilterSet("createdDateRangeStart") ||
          this.state.expanded) &&
          this.state.defaultFilters.indexOf("createdDateRangeStart") < 0 && (
            <Grid item>{filterObj.createdDateRangeStart}</Grid>
          )}
        {(!this.props.isFilterSet("createdDateRangeEnd") ||
          this.state.expanded) &&
          this.state.defaultFilters.indexOf("createdDateRangeEnd") < 0 && (
            <Grid item>{filterObj.createdDateRangeEnd}</Grid>
          )}
        {(!this.props.isFilterSet("lastModifiedDateRangeStart") ||
          this.state.expanded) &&
          this.state.defaultFilters.indexOf("lastModifiedDateRangeStart") <
            0 && <Grid item>{filterObj.lastModifiedDateRangeStart}</Grid>}
        {(!this.props.isFilterSet("lastModifiedDateRangeEnd") ||
          this.state.expanded) &&
          this.state.defaultFilters.indexOf("lastModifiedDateRangeEnd") < 0 && (
            <Grid item>{filterObj.lastModifiedDateRangeEnd}</Grid>
          )}
      </>
    );
    return (
      <>
        {this.props.asPopper ? (
          <div className={classes.container}>
            <>{defaultFilters}</>
            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                {wordSummary}
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.formWrapper}>
                {wordDetails}
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                {this.props.isFilterSet("createdDateRangeStart") ||
                this.props.isFilterSet("createdDateRangeEnd") ||
                this.props.isFilterSet("lastModifiedDateRangeStart") ||
                this.props.isFilterSet("lastModifiedDateRangeEnd") ? (
                  <StyledBadge
                    color="secondary"
                    variant="dot"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <Trans i18nKey="global_sort_dates" />
                  </StyledBadge>
                ) : (
                  <Trans i18nKey="global_sort_dates" />
                )}
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.formWrapper}>
                {dateDetails}
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        ) : (
          <Paper classes={{ root: classes.paperRoot }}>
            {/* <KpsListItem
              onToggle={(expanded) => this.setState({expanded: expanded})}
              isPortlet={false}
              preText={this.props.preText}
              provided={this.props.provided}
              onItemClick={(event) => event && event.stopPropagation()}          
              extendedString={
                  <>
                    <Grid container><div className={classes.expandedContainer}>{dateDetails}{wordDetails}</div></Grid>
                  </>
              }
            >
              {this.props.preText}
              <ListItemText
                // primary={<div className={classes.filterLine}>{defaultFilters}{activeFilters}</div>}
                primary={<Grid container>{defaultFilters}{activeFilters}</Grid>}
                secondary={""}
              />
            </KpsListItem>      */}
            <div style={{ display: "flex" }}>
              <IconButton
                id="reset-search-filters"
                onClick={this.props.resetToDefaultFilters}
                color={this.props.showReset === true ? "secondary" : "default"}
                disabled={this.props.showReset === false}
                aria-label="Reset search filters"
              >
                <Icon
                  path={
                    this.props.showReset === true
                      ? mdiFilterVariantRemove
                      : mdiFilterVariant
                  }
                  size={1.5}
                />
              </IconButton>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                {defaultFilters}
                {activeFilters}
              </div>

              <div
                style={{
                  marginLeft: "auto",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconButton
                  id="search-filter-expand"
                  aria-label={
                    this.state.expanded
                      ? "Show less filters"
                      : "Show more filters"
                  }
                  onClick={() =>
                    this.setState({ expanded: !this.state.expanded })
                  }
                >
                  {this.state.expanded ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </IconButton>
              </div>
            </div>
            <Collapse in={this.state.expanded}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                <div className={classes.expandedContainer}>
                  {dateDetails}
                  {wordDetails}
                </div>
              </div>
            </Collapse>
          </Paper>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  documentTypes: state.prefs.documentTypes,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
  currentUser: state.user.currentUser,
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {
  // setFilters,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withStyles(styles)(
    withTranslation()(withLastLocation(CoreFilter(SearchFilters)))
  )
);
